// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 801 ? "2d4dc074" : chunkId) + "." + {"11":"81ed8790a2beb203","601":"8b47c4e3b7647b2b","801":"45db7f0fe456a528"}[chunkId] + ".js";
};